import {DataFetcher} from '@aboutyou/data-fetcher';
import {
  BasketPageTitlePrice,
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  SIZE,
  SPACING,
  tabletAndUp,
} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';
import {useBasketPageTitleSection} from '../hooks/useGetBasketPageSection';
import {BasketPageTitleSkeleton} from './BasketPageTitle.skeleton';
import {BasketPageTitleProps, BasketPageTitleView} from './BasketPageTitleView';

export const BasketPageTitle: React.FC<
  BasketPageTitleProps & {className?: string}
> = props => {
  return (
    <>
      <TitleWrapper className={props.className}>
        <DataFetcher
          request={useBasketPageTitleSection()}
          View={BasketPageTitleView}
          Error={() => null}
          Loading={BasketPageTitleSkeleton}
          viewProps={props}
        />
      </TitleWrapper>
    </>
  );
};

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${FONT_SIZES.px20};
  font-weight: ${FONT_WEIGHTS.w500};
  color: ${COLORS.Black};

  ${BasketPageTitlePrice} {
    font-size: ${FONT_SIZES.px20};
  }

  &,
  h2 {
    line-height: 1rem;
  }

  h2 {
    margin: 0;
    display: flex;
  }

  ${tabletAndUp(css`
    min-height: ${SIZE.Xl2};
    margin: ${SPACING['Y.Lg']} ${SPACING['X.Md']} ${SPACING['Y.Xl']}
      ${SPACING['X.Lg']};
    padding: ${SPACING['Y.None']};
    justify-content: flex-start;
    font-size: ${FONT_SIZES.px32};
    margin-left: ${SPACING['X.None']};

    h2 {
      line-height: 1.5;
    }

    &:empty {
      min-height: ${SIZE.U0};
      margin: ${SPACING['Y.None']};
    }
  `)}
`;
